import React, {useEffect, useState} from 'react';
import {Button, Card, CardBody, Col, Container, Row, Tooltip} from "reactstrap";
import character from "../../assets/img/backgrounds/auth-character-right.png"
import {useHistory} from "react-router-dom";
import {trackGA4Event} from "../../util/Constants";

const Congratulation = (props) => {
    const history = useHistory();
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipText, setTooltipText] = useState("Copy Link");
    const [userType, setUserType] = useState(props.signedInUser.projectType);

    useEffect(() => {
        if (props?.userData?.eventData?.assessmentName) {
            const eventLabel= props?.userData?.eventData?.assessmentName;
            trackGA4Event("assessment created", eventLabel,props.signedInUser.projectType);
        }
    }, [])
    
    const toggle = () => setTooltipOpen(!tooltipOpen);

    const handleCopy = () => {
        navigator.clipboard.writeText(props?.userData?.eventData?.gameLink);
        setTooltipText('Copied!');
        setTimeout(() => {
            toggle()
        }, 1000);
        setTimeout(() => {
            setTooltipText('Copy Link');
        }, 2000)
    };
    const visitDashboard = () => {
        
        history.push("/assessment/dashboard");
    }
    const sendInvite = () => {
        history.push("/assessment/invitation/" + props?.userData?.eventData?.eventId);
    }

    return (
        <div>
            <Container className="mt-5">
                <div className="d-flex justify-content-center">
                    <Card className="step1-card br-15">
                        <CardBody className="startCard">
                            <Row>
                                <Col sm={12} lg={7} xs={12}>
                                    <div>
                                        <h3 className="font-weight-bold">Congratulation!</h3>
                                        <h4>Your {userType !== "progress" && "assessment"} Game has been created.</h4>
                                    </div>
                                    <div className="mt-5">
                                        <label className="fs-14 ml-2 font-weight-bolder text-muted">Game URL has been
                                            activated</label>
                                        <div
                                            className="d-flex assessment-input align-items-center justify-content-between p-2">
                                            <span className="w-100">{props?.userData?.eventData?.gameLink}</span>
                                            <Button className="nextButton text-white" id="copy"
                                                    onClick={handleCopy}>Copy</Button>
                                            <Tooltip
                                                placement="bottom"
                                                isOpen={tooltipOpen}
                                                target="copy"
                                                toggle={toggle}
                                                className="custom-tooltip"
                                            >
                                                {tooltipText}
                                            </Tooltip>
                                        </div>

                                    </div>
                                    <Row className="mt-6">
                                        <Col lg={6} sm={12} xs={12}>
                                            <Button className="previous-button text-white w-100"
                                                    onClick={visitDashboard}
                                                    color="">Visit Dashboard</Button>
                                        </Col>
                                        <Col lg={6} sm={12}>
                                            <Button className="nextButton px-sm-0 border-0 text-white px-5 w-100"
                                                    onClick={sendInvite}
                                                    color="">Send Invites</Button>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col sm={0} lg={5} xs={0} className="d-none d-lg-block">
                                    <img src={character} height={400}/>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
            </Container>
        </div>
    );
};

export default Congratulation;
